import React from 'react';
import type { AppContextInterface } from '~/containers/AppContainer/PrivateAppContainer';

export const AppCtx = React.createContext<AppContextInterface | null>(null);
